export class NivelCurso {
    id: number;    
    descricao: string;
}